import { render } from "./AddonCategories.vue?vue&type=template&id=1955452e&scoped=true"
import script from "./AddonCategories.vue?vue&type=script&lang=js"
export * from "./AddonCategories.vue?vue&type=script&lang=js"

import "./AddonCategories.vue?vue&type=style&index=0&id=1955452e&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1955452e"]])

export default __exports__